var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReverseIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 87,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.4 23.07a2 2 0 0 1 0 2.86l-22.84 22.5a2 2 0 0 1-3.4-1.43V2a2 2 0 0 1 3.4-1.42l22.84 22.5Z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36a24.96 24.96 0 0 1 24.94-25h13.97v26H38v-1ZM.6 63.93a2 2 0 0 1 0-2.86l22.84-22.5a2 2 0 0 1 3.4 1.43v45a2 2 0 0 1-3.4 1.42L.6 63.92Z",
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62 51a24.96 24.96 0 0 1-24.94 25H23.09V50H62v1Z",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverseIconLight);
export default __webpack_public_path__ + "static/media/reverse-icon-light.d939bb7e21cdb7c2c02bbb4cc0eb7b79.svg";
export { ForwardRef as ReactComponent };